<div class="container pt-3 fade-in-left" id="centerFrame">
  <div class="d-flex align-items-center justify-content-center mb-4 pe-5">
    <a (click)="back()">
      <div class="p-2"><i class="bi bi-chevron-left align-middle"></i></div>
    </a>

    <div class="p-2 flex-grow-1 pl-2">
      <h1 class="text-dark text-center">Elegí dónde recibir tus compras</h1>
    </div>

    <div class="p-2 pl-2 help" (click)="openhelp()">
      <i class="bi bi-info-circle"></i>
    </div>
  </div>

  <div class="row m-3 p-3 align-items-center" id="tooltip-pwa">
    <div class="col-auto">
      <i class="bi bi-info-circle" style="font-size: 1.8em;"></i>
    </div>
    <div class="col" id="helpinfo"></div>
    <div class="col-auto" (click)="openhelp()">
      <i class="bi bi-x-lg" style="font-size: 1.4em;"></i>
    </div>
  </div>

  <div class="row section-app fade-in col-lg-12 pe-0 pedidos justify-content-lg-end mb-md-4">
    <div class="row row-title align-items-center row-title-float pb-3">
      <div class="col-12 ps-4">
        <span class="title-description">
          Esta es tu libreta con las direcciones cargadas que podrás usar para tus compras.
        </span>
      </div>
    </div>
  </div>

  <div class="row-cols-12 m-2 mb-3 ms-0 me-0">
    <form (ngSubmit)="saveUbicacionDefault()" (keydown.enter)="$event.preventDefault()">

      @for (ubicacion of ubicaciones(); track trackByUbiId($index, ubicacion)) {
        <div class="row p-2 px-4 align-items-center notification mb-0">
          <hr class="divisor mt-3 mb-3">

          <div class="col-12 p-0">
            <input
              type="radio"
              class="form-check-input radio-ubicacion"
              [id]="ubicacion.id"
              [value]="ubicacion.id"
              [(ngModel)]="idUbicacionDefault"
              name="ubicacion"
            />

            <label [for]="ubicacion.id" class="label-radio-ubi">
              <div class="col">
                <div class="col-xl">
                  <div class="text-title-item">{{ ubicacion.x_domicilio }}</div>
                  <div class="text-subtitle-item">
                    {{ ubicacion.x_piso_dpto }}, C.P. {{ ubicacion.x_codigo_postal }}
                  </div>
                </div>
              </div>
            </label>
          </div>
        </div>
      } @empty {
        <div class="px-4 mt-3 text-muted">
          No tenés direcciones cargadas.
        </div>
      }

      <div class="row p-2 px-4 align-items-left mb-0 mt-0">
        <hr class="divisor mt-0 mb-2">
        <div class="col-auto link-letras" [routerLink]="['/my-account-ubicacion']">
          Agregar nueva dirección
        </div>
        <div class="col-auto link-letras border-start" [routerLink]="['/my-account-ubicaciones']">
          Editar direcciones
        </div>
        <hr class="divisor mt-2 mb-0">
      </div>

      @if (error().length > 0) {
        <div class="alert alert-danger mt-4 mx-4" role="alert">
          <small>{{ error() }}</small>
        </div>
      }

      <div class="d-grid mt-5 mb-3 pb-3">
        <button type="submit" class="btn btn-primary btn-lg mt-0">
          Aceptar
        </button>
      </div>
    </form>
  </div>
</div>
